import React, { useMemo, useState } from 'react'
import { Checkbox, Empty, Input, Space, Tag, Tree } from 'antd'
import HelpHint from './HelpHint'

// 2026-10-27 coder(lq): 严格控制勾选身份，父菜单不会因子项全选而隐式获得接口；搜索只隐藏节点，不丢弃已选范围。
export default function PolicyMenuTree({ scope, selection, disabled, onChange }) {
    const [search, setSearch] = useState('')
    const index = useMemo(() => {
        const nodes = new Map()
        const visit = node => {
            const descendants = [...(!node.disabled ? [node.key] : []), ...node.children.flatMap(visit)]
            nodes.set(node.key, descendants); return descendants
        }
        scope.tree.forEach(visit)
        return nodes
    }, [scope])
    const [expanded, setExpanded] = useState(() => Array.from(index.keys()))
    const tree = useMemo(() => {
        const text = search.trim().toLowerCase()
        const filter = node => {
            if (!text || `${node.title} ${node.menu.resource_id}`.toLowerCase().includes(text)) return node
            const children = node.children.map(filter).filter(Boolean)
            return children.length ? { ...node, children } : null
        }
        return scope.tree.map(filter).filter(Boolean)
    }, [scope, search])
    const selected = new Set(selection.keys), checked = [], halfChecked = []
    for (const [key, keys] of index) {
        const count = keys.filter(item => selected.has(item)).length
        if (count && count === keys.length) checked.push(key)
        else if (count) halfChecked.push(key)
    }
    return <div className="menu-api-policy-menus">
        <Space className="menu-api-policy-menu-tools">
            <Checkbox aria-label={`全选${scope.title}菜单`} disabled={disabled || !scope.keys.length}
                checked={!!scope.keys.length && selection.keys.length === scope.keys.length}
                indeterminate={selection.keys.length > 0 && selection.keys.length < scope.keys.length}
                onChange={event => onChange(event.target.checked ? scope.keys : [])}>全选菜单</Checkbox>
            <span>已选 {selection.keys.length} / {scope.keys.length}</span>
            <HelpHint label="菜单勾选说明">勾选目录会选择当前已读取的全部下级；取消目录会取消这些下级。搜索只影响显示。
                零接口关系菜单也可预先选择，但不会补导接口；后续新增菜单不自动加入本次精确选择。</HelpHint>
        </Space>
        <Input.Search allowClear aria-label="搜索待配置菜单" placeholder="搜索菜单名称或 ID" value={search}
            onChange={event => setSearch(event.target.value)} />
        {tree.length ? <div className="menu-api-policy-tree"><Tree checkable checkStrictly blockNode selectable={false}
            disabled={disabled} treeData={tree} expandedKeys={search.trim() ? Array.from(index.keys()) : expanded} onExpand={setExpanded}
            checkedKeys={{ checked, halfChecked }}
            onCheck={(_, info) => {
                const next = new Set(selection.keys)
                ;(index.get(info.node.key) || []).forEach(key => info.checked ? next.add(key) : next.delete(key))
                onChange(Array.from(next))
            }} titleRender={node => <span className="menu-api-tree-title">
                <span className="menu-api-tree-label">{node.title}</span>
                {node.hierarchyIssue && <HelpHint label={`${node.title}层级异常说明`}>{node.hierarchyIssue}</HelpHint>}
                <Tag title="当前菜单直接关联的接口数，不含下级">{node.count}<span className="menu-api-policy-count-label"> 条接口关系</span></Tag>
                {node.disabled && <small>已停用</small>}
            </span>} /></div> : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="没有匹配的菜单" />}
    </div>
}
